export default __webpack_public_path__ + "static/media/myjourney-graycircle.3413b263.svg";